import { useRef } from 'react'

import DocumentsFilters from './DocumentsFilters'
import Button from '../../../../common/Button'

import classes from './DocumentControls.module.css'
import { useUserTabEditPermissionDisabled } from '../../../../../lib/usersPermissions'

export default function DocumentControls({setUploaded}) {

    let userPermissionUpload = useUserTabEditPermissionDisabled('procodocs_documents_upload')


    const inputRef = useRef(null)
    const onFileDrop = (e) => {
        if (e.target.files.length > 0) {
            let filesArray = Array.from(e.target.files).map(item => {                
                return {
                    id: Math.random(),
                    file: item.name,
                    file_to_upload: item,
                    practices: null,
                    procodocs_document_type_id: null,
                    notes: null
                }
            })
            setUploaded(filesArray) 
        }
	}

    const openUploadHandler = () => {
        inputRef.current.click()
    }

    
    return <div className={classes.container}>
        <DocumentsFilters />
        <input ref={inputRef} type="file" value="" onChange={onFileDrop} multiple name="upload_number_1" id="upload_number_1" style={{display: 'none'}}/>
        {userPermissionUpload && <Button click={openUploadHandler}>
            <i className="ti ti-square-plus"></i>
            Upload new document
        </Button>}
    </div>
}